<script setup lang="ts">
import RoutePreloader from '@/components/RoutePreloader.vue'
</script>

<template>
  <RoutePreloader />
  <router-view />
</template>
